import { Component } from '@angular/core';

@Component({
    selector: 'edit-mapping',
    templateUrl: './edit-mapping.component.html'
})
export class EditMappingComponent {

}



// WEBPACK FOOTER //
// ./src/app/admin/importclient/mappingfilters/editmapping/edit-mapping.component.ts